import React, { useState } from 'react';
import { useParams, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { DomainTab } from './DomainTab';
import { KeywordsTab } from './KeywordsTab';
import { SettingsTab } from './SettingsTab';
import { DomainDetails } from './DomainDetails';
export const BrandPage: React.FC = () => {
  const {
    brandId
  } = useParams<{
    brandId: string;
  }>();
  // Mock brand data
  const brand = {
    id: parseInt(brandId || '0'),
    name: brandId === '1' ? 'Acme Inc' : brandId === '2' ? 'TechGiant' : 'SecureWeb'
  };
  return <div className="space-y-6" data-id="element-22">
      <div className="border-b border-gray-200" data-id="element-23">
        <div className="flex flex-col space-y-4 md:flex-row md:items-center md:space-y-0 md:space-x-8" data-id="element-24">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-25">{brand.name}</h1>
          <nav className="flex space-x-4 md:space-x-8" data-id="element-26">
            <NavLink to={`/brand/${brandId}/domains`} className={({
            isActive
          }) => isActive ? 'border-b-2 border-blue-500 py-4 px-1 text-sm font-medium text-blue-600' : 'border-b-2 border-transparent py-4 px-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700'} data-id="element-27">
              Domains
              <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-900" data-id="element-28">
                4
              </span>
            </NavLink>
            <NavLink to={`/brand/${brandId}/keywords`} className={({
            isActive
          }) => isActive ? 'border-b-2 border-blue-500 py-4 px-1 text-sm font-medium text-blue-600' : 'border-b-2 border-transparent py-4 px-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700'} data-id="element-29">
              Keywords
              <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-900" data-id="element-30">
                4
              </span>
            </NavLink>
            <NavLink to={`/brand/${brandId}/settings`} className={({
            isActive
          }) => isActive ? 'border-b-2 border-blue-500 py-4 px-1 text-sm font-medium text-blue-600' : 'border-b-2 border-transparent py-4 px-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700'} data-id="element-31">
              Settings
            </NavLink>
          </nav>
        </div>
      </div>
      <div data-id="element-32">
        <Routes data-id="element-33">
          <Route path="/" element={<Navigate to={`/brand/${brandId}/domains`} replace data-id="element-35" />} data-id="element-34" />
          <Route path="/domains" element={<DomainTab brandId={parseInt(brandId || '0')} data-id="element-37" />} data-id="element-36" />
          <Route path="/domains/:domainId" element={<DomainDetails brandId={parseInt(brandId || '0')} data-id="element-39" />} data-id="element-38" />
          <Route path="/keywords" element={<KeywordsTab brandId={parseInt(brandId || '0')} data-id="element-41" />} data-id="element-40" />
          <Route path="/settings" element={<SettingsTab brandId={parseInt(brandId || '0')} data-id="element-43" />} data-id="element-42" />
        </Routes>
      </div>
    </div>;
};